
import deMessages from '../locales/de-DE';

const DeLang = {
    messages: {
        ...deMessages
    },
    locale: 'de-DE',
  
};
export default DeLang;